export const translation = {
  // SEO & Meta
  siteName: 'CSSBuy Spreadsheet',
  siteDescription: 'Finden Sie das CSSBuy Spreadsheet, Kaufanleitungen, QC-Informationen, Lager, Versand, Coupons und Bewertungen.',
  title: 'CSSBuy Spreadsheet 2026: Guides, Angebote, QC & Versand',
  metaDescription: 'Finden Sie das CSSBuy Spreadsheet, Kaufanleitungen, Informationen zu QC, Lager, Versand, Coupons und Bewertungen. Vergleichen Sie Optionen und finden Sie aktualisierte Ressourcen für Ihre Einkäufe.',
  
  // Navigation
  navHome: 'Startseite',
  navGuide: 'Guide',
  navReview: 'Review',
  navShipping: 'Versand',
  navCoupon: 'Coupon',
  navWarehouse: 'Lager',
  navSafety: 'Sicherheit',
  navFAQ: 'FAQ',
  navAbout: 'Über uns',
  navContact: 'Kontakt',
  navArticle: 'Artikel',
  navShoppingGuide: 'Einkaufsführer',
  navGuides: 'Guides',
  
  // Language
  language: 'Sprache',
  pt: 'Português',
  de: 'Deutsch',
  en: 'English',
  
  // Categories
  categoriesTitle: 'Kategorien',
  categoriesDropdown: 'Kategorie auswählen',
  shoes: 'Shoes',
  hoodiesSweaters: 'Hoodies/Sweaters',
  tShirts: 'T-Shirts',
  jackets: 'Jackets',
  pantsShorts: 'Pants/Shorts',
  headwear: 'Headwear',
  sets: 'Sets',
  underwear: 'Underwear/Underpants',
  jersey: 'Jersey',
  accessories: 'Accessories',
  bags: 'Bags',
  belts: 'Belts',
  perfumes: 'Perfumes',
  otherStuff: 'Other Stuff',
  
  // Hero
  heroH1: 'CSSBuy Spreadsheet: Produkte, Guides und Informationen an einem Ort',
  heroSubtitle: 'Erkunden Sie das CSSBuy Spreadsheet, entdecken Sie Produkte, vergleichen Sie Informationen und lernen Sie, CSSBuy sicherer und effizienter zu nutzen.',
  heroCtaPrimary: 'CSSBuy Spreadsheet erkunden',
  heroCtaSecondary: 'Vollständigen Guide ansehen',
  heroTrust: 'Unabhängige Informationen • Aktualisierte Guides • Organisierte Ressourcen',
  heroDisclaimer: 'Diese Website ist eine unabhängige Ressource und repräsentiert nicht offiziell CSSBuy.',
  
  // What is
  whatIsTitle: 'Was ist das CSSBuy Spreadsheet?',
  whatIsH2: 'CSSBuy Spreadsheet: Alles, was Sie für bessere Recherche brauchen',
  whatIsDesc: 'Das CSSBuy Spreadsheet ist eine praktische Möglichkeit, Informationen zu Produkten, Kategorien, Links und Ressourcen zu organisieren und zu finden. Nutzen Sie organisierte Ressourcen, um Optionen zu vergleichen und effizienter zu recherchieren.',
  whatIsWarning: 'Vor dem Kauf bestätigen Sie immer den aktuellen Link, Verkäufer, Preis, Verfügbarkeit, QC und Versandbedingungen.',
  whatIsCta: 'CSSBuy Spreadsheet erkunden →',
  
  // Why Use
  whyUseTitle: 'Warum das CSSBuy Spreadsheet nutzen?',
  whyUseH2: 'Ein einfacher Ort zum Recherchieren, Vergleichen und Lernen',
  whyFindTitle: 'Schnell finden',
  whyFindDesc: 'Durchsuchen Sie Kategorien und Ressourcen im Zusammenhang mit dem CSSBuy Spreadsheet.',
  whyCompareTitle: 'Optionen vergleichen',
  whyCompareDesc: 'Vergleichen Sie Produkte und Informationen in organisierten Tabellen.',
  whyShippingTitle: 'Versand verstehen',
  whyShippingDesc: 'Lernen Sie über Gewicht, Versand und Konsolidierung.',
  whyQCTitle: 'QC prüfen',
  whyQCDesc: 'Lernen Sie, Qualitätskontrollfotos zu analysieren.',
  whySafetyTitle: 'Informierter einkaufen',
  whySafetyDesc: 'Konsultieren Sie Sicherheitsressourcen vor dem Kauf.',
  
  // Commercial Cards
  commercialTitle: 'CSSBuy Ressourcen',
  reviewTitle: 'CSSBuy Review',
  reviewDesc: 'Unabhängige Analyse zu Funktionen, Erfahrung, Vorteilen und Aufmerksamkeitspunkten.',
  reviewCta: 'CSSBuy Review lesen →',
  shippingCostTitle: 'CSSBuy Shipping Cost',
  shippingCostDesc: 'Verstehen Sie die Hauptfaktoren, die die Versandkosten beeinflussen.',
  shippingCostCta: 'Shipping Cost Guide ansehen →',
  couponTitle: 'CSSBuy Coupon',
  couponDesc: 'Informationen über aktuelle Coupons und Aktionen.',
  couponCta: 'Coupon Guide ansehen →',
  discountCodeTitle: 'CSSBuy Discount Code',
  discountCodeDesc: 'So überprüfen Sie Rabattcodes und Aktionen.',
  discountCodeCta: 'Discount Code Guide ansehen →',
  warehouseTitle: 'CSSBuy Warehouse',
  warehouseDesc: 'Informationen zu Lagerung, QC und Vorbereitung.',
  warehouseCta: 'Warehouse Guide ansehen →',
  legitTitle: 'Is CSSBuy Legit?',
  legitDesc: 'Sicherheits- und Verifizierungsinformationen.',
  legitCta: 'CSSBuy Legit Guide lesen →',
  
  // Comparison
  comparisonTitle: 'Vor dem Kauf vergleichen',
  comparisonH2: 'CSSBuy Spreadsheet: Vor dem Kauf vergleichen',
  comparisonFeature: 'Funktion',
  comparisonCssbuy: 'CSSBuy',
  comparisonAlternative: 'Alternative',
  comparisonProductResearch: 'Product Research',
  comparisonSpreadsheetResources: 'Spreadsheet Resources',
  comparisonQCInfo: 'QC Information',
  comparisonShippingGuide: 'Shipping Guide',
  comparisonWarehouseGuide: 'Warehouse Guide',
  comparisonSafetyGuide: 'Safety Guide',
  comparisonYes: '✓',
  
  // FAQ
  faqTitle: 'FAQ',
  faqH2: 'CSSBuy Spreadsheet FAQ',
  faq1Q: 'What is CSSBuy Spreadsheet?',
  faq1A: 'Das CSSBuy Spreadsheet ist ein Ressourcenorganisationstool für Käufer, um Produkte und Kategorien strukturiert zu recherchieren.',
  faq2Q: 'How does CSSBuy Spreadsheet work?',
  faq2A: 'Es organisiert Links, Kategorien und Informationen in einem zugänglichen Format, um die Produktsuche zu erleichtern.',
  faq3Q: 'How do I use CSSBuy Spreadsheet?',
  faq3A: 'Navigieren Sie durch die Kategorien, prüfen Sie die Links und verifizieren Sie immer Verkäufer und QC vor dem Kauf.',
  faq4Q: 'Is CSSBuy legit?',
  faq4A: 'CSSBuy ist ein bekannter Einkaufsagent. Verifizieren Sie immer Links und Verkäufer vor dem Kauf.',
  faq5Q: 'Is CSSBuy safe?',
  faq5A: 'Befolgen Sie Sicherheitspraktiken: Verifizieren Sie Domains, Links, QC und teilen Sie niemals Passwörter.',
  faq6Q: 'How much does CSSBuy shipping cost?',
  faq6A: 'Die Kosten hängen von Gewicht, Abmessungen, Versandlinie und Zielort ab. Nutzen Sie Guides für Schätzungen.',
  faq7Q: 'Does CSSBuy have coupons?',
  faq7A: 'Coupons und Rabattcodes können verfügbar sein. Prüfen Sie offizielle und aktualisierte Quellen.',
  faq8Q: 'What is the CSSBuy discount code?',
  faq8A: 'Rabattcodes variieren. Prüfen Sie immer die Gültigkeit und vertrauenswürdige Quellen.',
  faq9Q: 'How does CSSBuy warehouse work?',
  faq9A: 'Das Lager empfängt, inspiziert und bereitet Pakete für den Versand vor. Konsultieren Sie Guides für Details.',
  faq10Q: 'What is CSSBuy QC?',
  faq10A: 'QC (Quality Control) sind Inspektionsfotos des Produkts vor dem Versand.',
  
  // Final CTA
  finalCtaTitle: 'Bereit, das CSSBuy Spreadsheet zu erkunden?',
  finalCtaDesc: 'Finden Sie Guides, Ressourcen, Vergleiche und nützliche Informationen für bessere Recherche.',
  finalCtaPrimary: 'CSSBuy Spreadsheet erkunden →',
  finalCtaSecondary: 'Vollständigen Guide besuchen →',
  
  // Buttons
  cssbuySpreadsheet: 'CSSBuy Spreadsheet',
  buyItNow: 'Buy it now',
  exploreNow: 'Jetzt erkunden',
  readMore: 'Mehr lesen',
  viewGuide: 'Guide ansehen',
  
  // Footer
  footerDisclaimer: 'cssbuybr.surf ist eine unabhängige Informationsressource. CSSBuy-Namen, Marken und Drittanbieterdienste gehören ihren jeweiligen Eigentümern.',
  footerPrivacy: 'Datenschutz',
  footerTerms: 'Nutzungsbedingungen',
  footerDisclaimerLink: 'Haftungsausschluss',
  footerContact: 'Kontakt',
  
  // Article Page
  articleTitle: 'CSSBuy Spreadsheet: Kompletter Guide 2026',
  articleH1: 'CSSBuy Spreadsheet – Complete Guide',
  articleBackToHome: '← Zurück zur Startseite',
  articleMeta: 'Veröffentlicht am 26. August 2026 • Aktualisiert am 26. August 2026',
  articleAuthor: 'Autor: CSSBuy Resource Team',
  
  // Article Sections
  articleToc: 'Inhalt',
  articleWhatIs: 'Was ist das CSSBuy Spreadsheet?',
  articleHowWorks: 'Wie funktioniert das CSSBuy Spreadsheet?',
  articleFindProducts: 'So finden Sie Produkte',
  articleReadSpreadsheet: 'So lesen Sie eine Tabelle',
  articleCategories: 'Produktkategorien',
  articleSellerInfo: 'Verkäuferinformationen',
  articleQC: 'QC (Quality Control)',
  articleWarehouse: 'Lager',
  articleShipping: 'Versand',
  articleSafety: 'Sicherheit',
  articleMistakes: 'Häufige Fehler',
  articleComparison: 'Vergleich',
  articleFAQ: 'FAQ',
  
  // Safety Page
  safetyH1: 'CSSBuy Safety Guide',
  safetyVerifyDomain: 'Domain verifizieren',
  safetyVerifyLinks: 'Produktlinks verifizieren',
  safetyCheckSeller: 'Verkäufer prüfen',
  safetyReviewQC: 'QC überprüfen',
  safetyConfirmPrice: 'Preis bestätigen',
  safetyConfirmShipping: 'Versandkosten bestätigen',
  safetyNeverSharePassword: 'Passwörter niemals teilen',
  safetyAvoidPayment: 'Verdächtige Zahlungsaufforderungen vermeiden',
  safetyVerifyCoupons: 'Coupons verifizieren',
  safetyCheckPolicies: 'Aktuelle Richtlinien prüfen',
  safetyBewareFake: 'Vorsicht vor gefälschten Websites',
  
  // Announcement
  announcement: 'Unabhängige Ressource • Keine offizielle CSSBuy-Website',
  
  // Breadcrumb
  breadcrumbHome: 'Startseite',
  breadcrumbArticle: 'Artikel',
  
  // Schema / Meta
  metaKeywords: 'CSSBuy Spreadsheet, CSSBuy Review, CSSBuy Shipping, CSSBuy Coupon, CSSBuy Discount Code, CSSBuy Warehouse, CSSBuy Legit, CSSBuy QC',
  ogTitle: 'CSSBuy Spreadsheet 2026: Guides, Angebote, QC & Versand',
  ogDescription: 'Finden Sie das CSSBuy Spreadsheet, Kaufanleitungen, Informationen zu QC, Lager, Versand, Coupons und Bewertungen.',
  
  // Related Articles
  relatedArticles: 'Verwandte Artikel',
  relatedReview: 'CSSBuy Review 2026',
  relatedShipping: 'CSSBuy Shipping Cost Guide',
  relatedCoupon: 'CSSBuy Coupon Guide',
  relatedWarehouse: 'CSSBuy Warehouse Guide',
  relatedLegit: 'Is CSSBuy Legit?',
  relatedQC: 'CSSBuy QC Guide',
  
  // Internal Link Anchors
  linkSpreadsheet: 'CSSBuy Spreadsheet',
  linkSpreadsheetGuide: 'CSSBuy spreadsheet guide',
  linkSpreadsheetResources: 'spreadsheet resources',
  linkBuyingGuide: 'CSSBuy buying guide',
  linkQCGuide: 'CSSBuy QC guide',
  linkShippingGuide: 'CSSBuy shipping guide',
  linkSafetyGuide: 'CSSBuy safety guide',
  
  // Product category cards on homepage
  productCategoriesTitle: 'Beliebte Kategorien',
  productCategoriesDesc: 'Erkunden Sie die wichtigsten CSSBuy Spreadsheet-Kategorien',
  
  // Latest Guides
  latestGuidesTitle: 'Neueste Guides',
  latestGuidesDesc: 'Aktualisierte Guides über CSSBuy',
  pillarSectionLabel: 'Ausführliche Guides',
  pillarSectionTitle: 'CSSBuy Hauptguides',
  pillarSectionDesc: 'Entdecken Sie unsere vollständige Sammlung ausführlicher CSSBuy-Guides zu jeder Phase Ihrer Einkaufsreise.',
  
  // Trust Badges
  trustIndependent: 'Unabhängige Informationen',
  trustUpdated: 'Aktualisierte Guides',
  trustOrganized: 'Organisierte Ressourcen',

  // Product showcase
  allProducts: 'Alle Produkte',
  productsSectionLabel: 'Produktkatalog',
  productsSectionTitle: 'Empfohlene Produkte aus dem CSSBuy Spreadsheet',
  productsSectionDesc: 'Durchsuchen Sie unsere kuratierte Produktauswahl. Klicken Sie auf ein Element, um Details anzuzeigen und auf kaspreadsheet.com zu kaufen.',
  buyNow: 'Jetzt Kaufen',
  loadMore: 'Mehr Produkte Laden',
  showingCount: 'Zeige {{visible}} von {{total}} Produkten',
};

export default translation;